module.exports = "<nav role=\"navigation\" class=\"loginNavigation navigation\">\r\n    <h2 class=\"sr-only\">Authentication navigation</h2>\r\n    <ul class=\"navigation-items\">\r\n        <li>\r\n            <a ui-sref=\"shop.authentication.login\" ui-sref-active=\"is-active\" class=\"navigation-link\">Login</a>\r\n        </li>\r\n    </ul>\r\n</nav>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/login/login-navigation-template.html
 ** module id = 965
 ** module chunks = 1
 **/